<template>
  <div>
    <basic-container>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @search-change="searchChange"
        @refresh-change="refreshChange(page)"
        @search-reset="searchClear"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      >
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
import { appointmentCardDetailOption } from "@/const/work/appointmentCardDetail";
import { findDetails } from "@/api/work/appointmentCardDetail";

export default {
  name: "appointmentCardDetail",
  data() {
    return {
      tableOption: appointmentCardDetailOption, //表格设置属性
      tableData: [], //表格的数据
      tableLoading: false,
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10, //每页显示多少条
      },
    };
  },
  created() {
    this.handleList();
  },
  watch: {},
  mounted() {},
  computed: {},
  props: [],
  methods: {
    clean() {
      this.classifySelects = [];
    },
    searchClear() {},
    choseClassifyItem() {
      console.log(this.currClassify);
    },
    // ...
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.shopId = this.$route.query.id;
      params.page = this.page.currentPage;
      params.size = pageSize;
      this.downloadData = params;
      findDetails(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.tableData.forEach((item) => {
          item.shopName = this.$route.query.shopName;
        });
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize,
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.shopId = this.$route.query.id;
      params.page = page;
      params.size = this.page.pageSize;
      this.downloadData = params;
      findDetails(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.tableData.forEach((item) => {
          item.shopName = this.$route.query.shopName;
        });
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.shopId = this.$route.query.id;
      params.page = page.currentPage;
      params.size = page.pageSize;
      this.downloadData = params;
      findDetails(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.tableData.forEach((item) => {
          item.shopName = this.$route.query.shopName;
        });
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    // ...

    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      (params.shopId = this.$route.query.id), console.log(params);
      findDetails(params).then((res) => {
        if (res.code != 500) {
          let data = JSON.parse(res.data);
          this.tableData = data.rows;
          this.tableData.forEach((item) => {
            item.shopName = this.$route.query.shopName;
          });
          this.page = {
            total: data.total,
            currentPage: params.page,
            pageSize: params.size,
          };
          this.tableLoading = false;
        } else {
          this.tableLoading = false;
          this.tableData = [];
          console.log(11);
        }
      });
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      // this.clean()
      this.clean();
      this.$refs.crud.rowAdd();
    },
    handleEdit(row, index) {
      console.log(row);
      this.clean();
      this.currClassify = row.rootId == 0 ? (row.rootId = "") : row.rootId;
      this.$refs.crud.rowEdit(row, index);
    },

    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let params = {
        shopId: this.$route.query.id,
        page: this.page.currentPage,
        size: this.page.pageSize,
      };
      this.downloadData = params;
      findDetails(params).then((res) => {
        let data = JSON.parse(res.data);
        data.rows.forEach((item) => {
          item.shopName = this.$route.query.shopName;
        });
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize,
        };
        console.log(this.page);
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/

    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/

    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
  },
};
</script>

<style lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
